import { Paragraph } from '@eggplant/pattern-library'

const LimitedConnectionType = () =>
  <Paragraph>
    Please note, that an optional connection is only available for certain types of primary connections. Depending on the primary connection you have chosen, only Webdriver is available as an optional connection.
  </Paragraph>

export default LimitedConnectionType
